import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-register-event',
  templateUrl: './register-event.component.html',
  styleUrls: ['./register-event.component.scss']
})
export class RegisterEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
